import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import {
  emitVeredict,
  changeStatus,
  sendToPublication,
  assignReviewer,
  applyTechnicalReview,
  getArticlesAmountForStatus,
} from "../features/editor/editorSlice";
import { editArticleStatus } from "../features/articles/articlesSlice";
import { deleteArticle } from "../features/authors/authorSlice";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(
    emitVeredict.fulfilled,
    changeStatus.fulfilled,
    sendToPublication.fulfilled,
    assignReviewer.fulfilled,
    applyTechnicalReview.fulfilled,
    deleteArticle.fulfilled,
    editArticleStatus.fulfilled,
  ),
  effect: async (_action, listenerApi) => {
    listenerApi.dispatch(getArticlesAmountForStatus());
  },
});
